'use strict'; // browsers can't stream. When the 'Send ReadableStream in request body' row
// is green here: https://developer.mozilla.org/en-US/docs/Web/API/Request/Request#Browser_compatibility
// we'll be able to wrap the passed iterator in the it-to-browser-readablestream module
// in the meantime we have to convert the whole thing to a BufferSource of some sort

var _regeneratorRuntime = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/eef137a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var toBuffer = require('it-to-buffer');

var _require = require('buffer'),
    Buffer = _require.Buffer;

module.exports = function (it) {
  function bufferise(_x) {
    return _bufferise.apply(this, arguments);
  }

  function _bufferise() {
    _bufferise = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 23;
                break;
              }

              chunk = _value;

              if (!Buffer.isBuffer(chunk)) {
                _context.next = 18;
                break;
              }

              _context.next = 16;
              return chunk;

            case 16:
              _context.next = 20;
              break;

            case 18:
              _context.next = 20;
              return Buffer.from(chunk);

            case 20:
              _iteratorNormalCompletion = true;
              _context.next = 4;
              break;

            case 23:
              _context.next = 29;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 29:
              _context.prev = 29;
              _context.prev = 30;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 34;
                break;
              }

              _context.next = 34;
              return _awaitAsyncGenerator(_iterator.return());

            case 34:
              _context.prev = 34;

              if (!_didIteratorError) {
                _context.next = 37;
                break;
              }

              throw _iteratorError;

            case 37:
              return _context.finish(34);

            case 38:
              return _context.finish(29);

            case 39:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 25, 29, 39], [30,, 34, 38]]);
    }));
    return _bufferise.apply(this, arguments);
  }

  return toBuffer(bufferise(it));
};